import React from "react";
import LoadingView from "@/components/ui/loading-view/LoadingView";

const LabelsView = React.lazy(() => import("./Labels.view"));

const LabelsLoadable = () => (
  <React.Suspense fallback={<LoadingView />}>
    <LabelsView />
  </React.Suspense>
);

export default () => <LabelsLoadable />;
